import type { DocumentRegister, GlobalClauseList } from "../api";
import styles from "./Clauses.module.css";

/** The chip's wording and tone for a register, shared by the badge and the Files
 * page's "Items with extracted clauses" section. */
export const registerChip = (
  register: DocumentRegister,
): { label: string; tone: string } => ({
  label:
    register.status === "building"
      ? "Extracting clauses"
      : register.status === "failed"
        ? "Clause extraction failed"
        : `Extracted clauses${
            !register.slot
              ? " (not in a role)"
              : !register.slot.active
                ? " (replaced)"
                : register.stale
                  ? " (out of date)"
                  : ""
          }`,
  tone:
    register.status === "failed"
      ? styles.chipBad
      : register.status === "building" ||
          register.stale ||
          !register.slot?.active
        ? styles.chipWarn
        : "",
});

/** The projects a Global data file applies to, by its tenant and landlord filters. */
export const scopeText = (scope: GlobalClauseList["scope"]): string =>
  [
    scope.tenant ? `Tenant: ${scope.tenant}` : "",
    scope.landlord ? `Landlord: ${scope.landlord}` : "",
  ]
    .filter(Boolean)
    .join(", ") || "Every project";
